import { defineComponent } from 'vue';
import { QDialog } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import BaseComponentMixin from './BaseComponentMixin.jsx';
import ControlPicker from './controlPicker.jsx';

export default defineComponent({
    name: 'carecenter-popupmenu-dsgn',
    mixins: [BaseComponentMixin],
    components: {
        QDialog,
        ControlPicker,
    },
    props: {
        //name: { type: String, default: '' },
        //root: { type: Object, default: null },
        //designmodel: { type: Object, default: null },
        //controlData: { type: Object, default: () => ({}) },
    },
    render() {
        let icontitle;
        if (this.designmodel.MenuItemData.Icon)
            icontitle = (
                <span style={{ fontSize: 'x-large' }}>
                    <i title={this.designmodel.MenuItemData.Icon.Tooltip} class={this.designmodel.MenuItemData.Icon} /> {this.designmodel.MenuItemData.Title}
                </span>
            );
        else
            icontitle = (
                <span style={{ fontSize: 'x-large' }}>
                    <i title="Undefined" class="mdi mdi-help-circle" /> {this.designmodel.MenuItemData.Title}
                </span>
            );

        if (!this.controlData || !this.controlData.Actions)
            return null;

        const items = [];
        for (let i = 0; i < this.controlData.Actions.length; i++) {
            const action = this.controlData.Actions[i];
            if (typeof action !== 'object')
                continue;

            let DynamicAction = utils.getDynamicAction(action);

            if (!DynamicAction)
                DynamicAction = 'default-unknown';

            DynamicAction += '-dsgn';

            let DynamicControl = utils.dynamicComponents[DynamicAction];
            if (!DynamicControl)
                DynamicControl = utils.dynamicComponents['default-unknown-dsgn'];

            if (!action.$objectId) action.$objectId = utils.generateUUID();

            items.push(
                <DynamicControl
                    key={action.$objectId}
                    type={action.ActionType}
                    root={this.root}
                    designmodel={action}
                    controlData={action.ActionData}
                />
            );
        }
        //const items = <div>Hello</div>;

        return (
            <div
                class={{ 'designer-container': true, selected: this.selected$ }}
                style={{ ...utils.getSize(this.controlData.SizeOptions) }}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ 'designer-container-hovering': true, 'designer-container-selected': this.selected$ }} />
                {icontitle}
                {this.name}<br />
                {items}
            </div>
        );
    },
});
